import { Input, OnDestroy, OnInit, Directive } from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';

@Directive()
export abstract class AbstractFieldComponent implements OnInit, OnDestroy {

  @Input() public form: UntypedFormGroup;
  @Input() public field_name;
  @Input() public value = '';
  @Input() public placeholder = '';

  @Input() public require = false;
  @Input() public disabled = false;
  @Input() public canRemove = false;
  @Input() public onChange;

  public control: UntypedFormControl;
  public formAdded = false;

  public ready: Promise<void>;
  public resolver: (...args) => any;
  public subscription: Subscription = new Subscription();

  constructor() {
    this.ready = new Promise<void>(resolver => this.resolver = resolver);
  }

  ngOnInit() {
    this.control = new UntypedFormControl(
      {value: this.value, disabled: this.disabled},
      this.require ? [Validators.required] : null
    );
    this.form.addControl(this.field_name, this.control);

    if (this.onChange) {
      this.subscription.add(this.control.valueChanges.subscribe(() => {
        this.onChange();
      }));
    }

    this.formAdded = true;

    this.resolver();
  }

  ngOnDestroy() {
    if (this.canRemove) {
      this.form.removeControl(this.field_name);
    }
    this.subscription.unsubscribe();
  }

}
